import {CredentialsInterface} from "@/types/Credentials";

export class Credentials implements CredentialsInterface {
  email!: string;
  password!: string;

  constructor(email: string, password: string) {
    this.email = email;
    this.password = password;
  }
}
